import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ChecklistComponent from "@Shared/components/checklist/checklist";
import TimelineCardFooter from "@Broker/@Modules/clients/board/client-profile/components/timeline/utils/timeline-card-footer.vue";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import Amplitude from "@Shared/utils/amplitude";
import Err from "@Broker/@Routes/error";
import { isEmpty } from "lodash";
import { showToast } from "@Shared/utils/constants";
import { mapActions } from "vuex";
import { EDIT_REFERRER_CHECKLIST, DELETE_REFERRER_CHECKLIST } from "@Broker/@Modules/clients/referrers/store/referrer-actions.ts";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ReferrerTimelineChecklist",
  components: {
    ChecklistComponent,
    TimelineCardFooter,
    InlinePrompt,
    ProfileAvatar
  },
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ""
    },
    creator: {
      type: Object,
      required: true
    },
    createdAt: {
      type: String,
      required: true
    },
    updatedAt: {
      type: String,
      required: true
    },
    activityType: {
      type: String,
      required: true
    },
    pinned: {
      type: Boolean,
      required: true
    },
    checklist: {
      type: Array,
      required: true
    },
    referrerId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      editingTitle: false,
      localData: {}
    };
  },
  computed: {
    name() {
      const {
        givenName,
        familyName
      } = this.creator;
      return this.$options.filters.nameFormat(givenName, familyName);
    },
    notUpdatedYet() {
      return this.createdAt === this.updatedAt;
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ReferrerStore", [EDIT_REFERRER_CHECKLIST, DELETE_REFERRER_CHECKLIST])), {}, {
    async handleUpdate({
      checklist,
      title
    }) {
      try {
        if (!this.editingTitle) {
          await this.EDIT_REFERRER_CHECKLIST({
            referrerId: this.referrerId,
            checklistId: this.id,
            data: checklist,
            title
          });
          showToast("success", "referrerChecklistUpdated");
        } else {
          this.localData = {
            checklist,
            title
          };
        }
      } catch (error) {
        Err.handle(error);
      }
    },
    handleEditChecklist() {
      this.editingTitle = !this.editingTitle;
      if (!(this.editingTitle || isEmpty(this.localData))) {
        this.handleUpdate(this.localData);
      }
    },
    async handleDelete() {
      try {
        await this.DELETE_REFERRER_CHECKLIST({
          referrerId: this.referrerId,
          checklistId: this.id
        });
        showToast("success", "referrerChecklistDeleted");
        Amplitude.logEvent("Referrer - checklist deleted", {
          page: "clients-board",
          checklistId: this.id,
          referrerId: this.referrerId
        });
      } catch (error) {
        Err.handle(error);
      }
    },
    handlePin(id, type, pinned) {
      this.$emit("pin", id, type, pinned);
    }
  })
});